import { render, staticRenderFns } from "./AllProduct.vue?vue&type=template&id=70b22a1d&"
import script from "./AllProduct.vue?vue&type=script&lang=js&"
export * from "./AllProduct.vue?vue&type=script&lang=js&"
import style0 from "./AllProduct.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports